import React from 'react';
export default function CheckSmallIcon() {
    return (React.createElement("svg", { height: "30", viewBox: "0 0 30 30", width: "30" },
        React.createElement("path", { d: "M12.1 22c-.4 0-.8-.1-1.1-.4l-5.1-5.2c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l4.1 4.1 9.8-9.8c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-10.9 10.9c-.2.3-.6.4-1 .4z", fill: "#fff" })));
}
